import { motion } from "framer-motion";
import "../style/HowItWorksStyle.css";

const HowItWorksSection = () => {
    const fadeInUp = {
        hidden: { opacity: 0, y: 30 },
        visible: { opacity: 1, y: 0 }
    };

    const handleClick = () => {
        if (window.fbq) {
            window.fbq('track', 'Lead', {
                content_name: 'Landing Page Create Your First Job (How It Works Section) Click',
                status: 'Initiated' // Custom parameter for clarity
            });
        }
        
        window.open("https://web.daydone.co.uk/signup", "_blank");
    };

    const steps = [
        {
            number: "1",
            title: "Create a Job",
            description: "Add the customer, what needs doing, and the date. That's it."
        },
        {
            number: "2",
            title: "Send a Quote",
            description: "Send a professional quote by SMS or email. Customers approve instantly — no chasing."
        },
        {
            number: "3",
            title: "Do the Work",
            description: "Your team sees their jobs, updates progress, and uploads photos."
        },
        {
            number: "4",
            title: "Get Paid",
            description: "Invoice automatically and see what's paid and what's not."
        }
    ];

    return (
        <section className="how-it-works-section">
            <div className="container">
                <motion.div
                    className="text-center mb-5"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, margin: "-100px" }}
                    variants={{
                        visible: {
                            transition: {
                                staggerChildren: 0.15
                            }
                        }
                    }}
                >
                    <motion.h2
                        className="section-title"
                        variants={fadeInUp}
                    >
                        Get Set Up in Minutes - Not Days
                    </motion.h2>
                    <motion.p
                        className="section-subtitle"
                        variants={fadeInUp}
                    >
                        Everything you need to run a job, start to finish.
                    </motion.p>
                </motion.div>

                <motion.div
                    className="row g-4 mb-5 px-5"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, margin: "-100px" }}
                    variants={{
                        visible: {
                            transition: {
                                staggerChildren: 0.2
                            }
                        }
                    }}
                >
                    {steps.map((step, index) => (
                        <motion.div
                            key={index}
                            className="col-12"
                            variants={fadeInUp}
                        >
                            <div className="step-card">
                                <div className="step-number-wrapper">
                                    <div className="step-number">{step.number}</div>
                                </div>
                                <div>

                                    <h3 className="step-title">{step.title}</h3>
                                    <p className="step-description">{step.description}</p>
                                </div>
                            </div>
                        </motion.div>
                    ))}
                </motion.div>

                <motion.div
                    className="text-center"
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: 0.8 }}
                >
                    <button className="cta-button" onClick={handleClick}>
                        Create Your First Job (Free)
                    </button>
                </motion.div>

                <motion.p
                    className="text-center mt-5"
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: 0.8 }}
                >
                    No setup, No contract, Cancel anytime
                </motion.p>
                <motion.p
                    className="text-center mt-2"
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: 0.8 }}
                >
                    Takes less then 2 minutes. No card required.
                </motion.p>
                <motion.p
                    className="text-center mt-2"
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: 0.8 }}
                >
                    Built for trades - plumbers, electricians, builders, cleaners.
                </motion.p>
            </div>
        </section>
    );
};

export default HowItWorksSection;